import { thunk } from "redux-thunk";
import storage from "redux-persist/lib/storage";
import userSlice from "./features/User/userSlice.js";
import adminSlice from "./features/Admin/adminSlice.js";
import doctorSlice from "./features/Doctor/doctorSlice.js";
import { persistReducer, persistStore } from "redux-persist";

import {
  configureStore,
  combineReducers,
  applyMiddleware,
} from "@reduxjs/toolkit";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userSlice,
  admin: adminSlice,
  doctor: doctorSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore(
  { reducer: persistedReducer },
  applyMiddleware(thunk)
);

export const persistor = persistStore(store);
